<div class="page-inner-body portlet light ms-3 ">
  <div class="portlet-body">
    <div class="table-toolbar p-2">
      <div class="row mt-4 p-2">
        <div class="row border shadow rounded-2 p-4">
          <!-- Left Section: Portfolio Description -->
          <div class="col-lg-5 col-md-12 border-end">
            <div class="d-flex flex-column">
              <!-- Heading with Portfolio Count -->
              <div class="d-flex align-items-center mb-3">

                <div class="d-flex align-items-center">
                  <h4 class="fw-bold text-dark mb-1">{{ 'shareableProduct.createPortfolioForSharing' | transloco }}</h4>
                  @if (artistProducts.length > 0) {
                    <span class="badge rounded-pill ms-2"
                      style="background-color: #2E8B8B; color: white;">
                      {{ artistProducts.length }}
                    </span>
                  }
                </div>
              </div>

              <!-- Descriptive Text -->
              <div class="text-muted">
                <div class="mb-3 p-3 rounded-3" style="background-color: #f8f9fa; border-left: 4px solid #2E8B8B;">
                  <div class="d-flex align-items-start mb-2">
                    <i class="pi pi-share-alt me-2 mt-1" style="color: #2E8B8B;"></i>
                    <div>
                      <h6 class="fw-semibold mb-1 text-dark">{{ 'shareableProduct.easySharing' | transloco }}</h6>
                      <p class="mb-0 small">
                        {{ 'shareableProduct.easySharingText' | transloco }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="mb-3 p-3 rounded-3" style="background-color: #f8f9fa; border-left: 4px solid #FF8C42;">
                  <div class="d-flex align-items-start">
                    <i class="pi pi-globe me-2 mt-1" style="color: #FF8C42;"></i>
                    <div>
                      <h6 class="fw-semibold mb-1 text-dark">{{ 'shareableProduct.platformIntegration' | transloco }}</h6>
                      <p class="mb-0 small">
                        {{ 'shareableProduct.platformIntegrationText' | transloco }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Right Section: Portfolio Table and Action Button -->
          <div class="col-lg-7 col-md-12">
            <div class="mt-lg-0 mt-4">
              <!-- Create Portfolio Button -->
              <div class="d-flex justify-content-end align-items-center mb-3">
                <button pButton type="button" [label]="'shareableProduct.createPortfolio' | transloco" icon="pi pi-plus" class="p-button-outlined"
                  style="border-color: #2E8B8B; color: #2E8B8B;" (click)="openPortfolioDialog()">
                </button>
              </div>

              <!-- Portfolio Table Container -->
              <div class="card border-1 shadow-sm">
                <div class="card-header bg-white border-bottom-1 py-3">
                  <div class="d-flex align-items-center justify-content-between">
                    <h6 class="fw-semibold mb-0 text-dark">
                      <i class="pi pi-list me-2" style="color: #2E8B8B;"></i>
                      {{ 'shareableProduct.yourPortfolios' | transloco }}
                    </h6>
                    @if (portfolioList.length > 0) {
                      <span class="badge rounded-pill"
                        style="background-color: #FF8C42; color: white;">
                        {{ portfolioList.length }}
                      </span>
                    }
                  </div>
                </div>

                <div class="card-body p-0" style="max-height: 500px; overflow-y: auto;">
                  <p-table [value]="portfolioList" styleClass="p-datatable-sm p-datatable-striped" [rows]="4"
                    [scrollable]="true" scrollHeight="350px">

                    <ng-template pTemplate="header">
                      <tr>
                        <th class="py-3 px-3">
                          <div class="fw-semibold">{{ 'shareableProduct.title' | transloco }}</div>
                        </th>
                        <th class="py-3 px-3 d-none d-sm-table-cell">
                          <div class="fw-semibold">{{ 'shareableProduct.status' | transloco }}</div>
                        </th>
                        <th class="py-3 px-3 d-none d-md-table-cell">
                          <div class="fw-semibold">{{ 'shareableProduct.date' | transloco }}</div>
                        </th>
                        <th class="py-3 px-3 text-center">
                          <div class="fw-semibold">{{ 'shareableProduct.actions' | transloco }}</div>
                        </th>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-item>
                      <tr [class.selected]="item.Id === selectedRowId" (click)="onRowClick(item.Id,item.IsActive)"
                        style="cursor: pointer;">

                        <td class="px-3 py-2" (click)="selectePortfolio(item)">
                          <div class="d-flex align-items-center justify-content-between">
                            <div>
                              <div class="fw-bold text-dark">{{ item.Title }}</div>
                              <!-- Mobile view: Show status and date below title -->
                              <div class="d-sm-none mt-1">
                                <span class="badge me-2"
                                  [style.background-color]="item.IsActive ? '#28a745' : '#6c757d'"
                                  style="color: white;">
                                  {{ item.IsActive ? ('shareableProduct.active' | transloco) : ('shareableProduct.inactive' | transloco) }}
                                </span>
                                <small class="text-muted">{{ item.CreatedDate | date: 'dd/MM/yyyy' }}</small>
                              </div>
                            </div>
                            <span class="ms-2" (click)="editPortfolioData($event,item.Id)">
                              <i class="pi pi-pencil" style="color: #2E8B8B; cursor: pointer;" [pTooltip]="'shareableProduct.editPortfolio' | transloco"
                              tooltipPosition="left"></i>
                            </span>
                          </div>
                        </td>

                        <td class="px-3 py-2 d-none d-sm-table-cell" (click)="selectePortfolio(item)">
                          <span class="badge" [style.background-color]="item.IsActive ? '#178d9b' : '#6c757d'"
                            style="color: white;">
                            {{ item.IsActive ? ('shareableProduct.active' | transloco) : ('shareableProduct.inactive' | transloco) }}
                          </span>
                        </td>

                        <td class="px-3 py-2 d-none d-md-table-cell" (click)="selectePortfolio(item)">
                          <small class="text-muted">{{ item.CreatedDate | date: 'dd/MM/yyyy' }}</small>
                        </td>

                        <td class="px-3 py-2">
                          <div class="d-flex justify-content-end align-items-center gap-1 flex-nowrap">
                            <button pButton icon="pi pi-cog" class="p-button-outlined p-button-sm"
                              style="border-color: #2E8B8B; color: #2E8B8B;" [pTooltip]="'shareableProduct.editPortfolioProducts' | transloco"
                              tooltipPosition="left" (click)="editPortfolio(item)">
                            </button>

                            <button pButton icon="pi pi-code" class="p-button-outlined p-button-sm"
                              style="border-color: #FF8C42; color: #FF8C42;" [pTooltip]="'shareableProduct.portfolioJsonLink' | transloco"
                              tooltipPosition="left" (click)="downloadPortfolio(item.Id)">
                            </button>

                            <button pButton icon="pi pi-copy" class="p-button-outlined p-button-sm"
                              style="border-color: #2E8B8B; color: #2E8B8B;" [pTooltip]="'shareableProduct.copyLink' | transloco" tooltipPosition="left"
                              (click)="portfolioTableCopyLink($event,item)">
                            </button>

                            <button pButton icon="pi pi-trash" class="p-button-outlined p-button-danger p-button-sm"
                              [pTooltip]="'shareableProduct.deletePortfolio' | transloco" tooltipPosition="left" (click)="onDeletePortfolio(item.Id)">
                            </button>

                            <!-- Hidden input for copy functionality -->
                            <div style="display: none;">
                              <input type="text" id="copyRowLink" class="form-control"
                                [(ngModel)]="sharePortfolioRowLink" readonly>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </ng-template>

                      <ng-template pTemplate="emptymessage">
                        <tr>
                          <td [attr.colspan]="4" class="text-center py-5">
                            <div class="d-flex flex-column align-items-center">
                              <div class="mb-3 p-4 rounded-circle"
                                style="background: linear-gradient(135deg, #2E8B8B 0%, #FF8C42 100%);">
                                <i class="pi pi-briefcase text-white" style="font-size: 2.5rem;"></i>
                              </div>
                              <h6 class="text-muted mb-2">{{ 'shareableProduct.noPortfoliosFound' | transloco }}</h6>
                              <p class="text-muted small mb-3">{{ 'shareableProduct.createFirstPortfolio' | transloco }}</p>
                              <button pButton [label]="'shareableProduct.createPortfolio' | transloco" icon="pi pi-plus" class="p-button-outlined"
                                style="border-color: #2E8B8B; color: #2E8B8B;" (click)="openPortfolioDialog()">
                              </button>
                            </div>
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <hr class=" mt-3 mb-2"> -->
          <div class="row d-flex mt-3 px-0">
            <!-- search dropdowns -->
            @if (isArtist) {
              @if (portfolioselections) {
                <div class="filters-container d-flex flex-wrap align-items-center gap-2 my-2">
                  <div class="form-group flex-fill" style="min-width: 130px;">
                    <p-dropdown [options]="artistArtTypes" inputId="artistArtTypes" [filter]="true" [filterBy]="'label'"
                      [optionLabel]="'label'" [optionValue]="'value'" name="artistArtTypes" [placeholder]="'shareableProduct.filterByArtType' | transloco"
                      [(ngModel)]="filters.ArtTypeId" [showClear]="true" (onChange)="onArtTypedChanged($event)">
                    </p-dropdown>
                  </div>
                  <div class="form-group flex-fill" style="min-width: 130px;">
                    <p-dropdown [options]="productCategories" inputId="productCategory" name="productCategory"
                      [filter]="true" [filterBy]="'label'" [optionLabel]="'label'" [optionValue]="'value'"
                      [placeholder]="'shareableProduct.filterByCategory' | transloco" [(ngModel)]="filters.ProductCategory" [disabled]="!filters.ArtTypeId"
                      [showClear]="true" (onChange)="onProductCategoriesChange($event)">
                    </p-dropdown>
                  </div>
                  <div class="form-group flex-fill" style="min-width: 130px;">
                    <p-dropdown [options]="productSeries" [filter]="true" [filterBy]="'label'" [optionLabel]="'label'"
                      [optionValue]="'value'" inputId="productSeries" name="productSeries" [placeholder]="'shareableProduct.filterBySeries' | transloco"
                      [(ngModel)]="filters.ProductSeriesId" [disabled]="!filters.ArtTypeId" [showClear]="true"
                      (onChange)="onProductSeriesChange($event)">
                    </p-dropdown>
                  </div>
                  <div class="form-group flex-fill" style="min-width: 130px;">
                    <p-dropdown [options]="galleries" [filter]="true" [filterBy]="'label'" [optionLabel]="'label'"
                      [optionValue]="'value'" inputId="galleries" name="galleries" [placeholder]="'shareableProduct.filterByGallery' | transloco"
                      [showClear]="true" [(ngModel)]="filters.GalleryId" (onChange)="onGalleriesChange($event)">
                    </p-dropdown>
                  </div>
                  <div class="form-group flex-fill" style="min-width: 130px;">
                    <p-dropdown [options]="statusFilterOptions" [filter]="false" inputId="statusFilter" name="statusFilter"
                      [placeholder]="'shareableProduct.filterByStatus' | transloco" [(ngModel)]="filters.Status" [showClear]="true"
                    (onChange)="onStatusFilterChange($event)"></p-dropdown>
                  </div>
                  <div class="form-group flex-fill" style="min-width: 130px;">
                    <input type="text" class="form-control" [placeholder]="'shareableProduct.filterItems' | transloco" [(ngModel)]="filters.Query"
                      (input)="onGlobalFilterProduct($event)" />
                    </div>
                    <div class="form-group">
                      <p-button type="button" icon="pi pi-times" iconPos="left" [outlined]="true" severity="secondary"
                      (click)="clearAllFilters($event)" class="p-button-sm" [label]="'shareableProduct.clearAll' | transloco"></p-button>
                    </div>
                  </div>
                }
              }

              @if (isGallery) {
                @if (portfolioselections) {
                  <div class="filters-container d-flex flex-wrap align-items-center gap-2 my-2">
                    <div class="form-group flex-fill" style="min-width: 130px;">
                      <p-dropdown [options]="productCategories" inputId="productCategory" name="productCategory"
                        [filter]="true" [filterBy]="'label'" [optionLabel]="'label'" [optionValue]="'value'"
                        [placeholder]="'shareableProduct.filterByCategory' | transloco" [(ngModel)]="filters.ProductCategory" [disabled]="!filters.ArtTypeId"
                        [showClear]="true" (onChange)="onProductCategoriesChange($event)">
                      </p-dropdown>
                    </div>
                    <div class="form-group flex-fill" style="min-width: 130px;">
                      <p-dropdown [options]="connectedArtists" [(ngModel)]="artistId" name="selectedArtistId"
                        (onChange)="onArtistChanged($event)" [filter]="true" [filterBy]="'label'" [optionLabel]="'label'"
                        [showClear]="true" [optionValue]="'value'" [placeholder]="'shareableProduct.filterByArtist' | transloco">
                      </p-dropdown>
                    </div>
                    <div class="form-group flex-fill" style="min-width: 130px;">
                      <p-dropdown [options]="artTypes" inputId="artistArtTypes" [filter]="true" [filterBy]="'label'"
                        [optionLabel]="'label'" [optionValue]="'value'" name="artistArtTypes" [placeholder]="'shareableProduct.filterByArtType' | transloco"
                        [showClear]="true" [(ngModel)]="filters.ArtTypeId"
                        (onChange)="onArtTypeChanged($event)">
                      </p-dropdown>
                    </div>
                    <div class="form-group flex-fill" style="min-width: 130px;">
                      <p-dropdown [options]="statusFilterOptions" [filter]="false" inputId="statusFilter" name="statusFilter"
                        [showClear]="true" [placeholder]="'shareableProduct.filterByStatus' | transloco" [(ngModel)]="filters.Status"
                      (onChange)="onStatusFilterChange($event)"></p-dropdown>
                    </div>
                    <div class="form-group flex-fill" style="min-width: 130px;">
                      <input type="text" class="form-control" [placeholder]="'shareableProduct.filterItems' | transloco" [(ngModel)]="filters.Query"
                        (input)="onGlobalFilterProduct($event)" />
                      </div>
                      <div class="form-group">
                        <p-button type="button" icon="pi pi-times" iconPos="left" [outlined]="true" severity="secondary"
                        (click)="clearAllFilters($event)" class="p-button-sm" [label]="'shareableProduct.clearAll' | transloco"></p-button>
                      </div>
                    </div>
                  }
                }
                @if (showMenuButton && !portfolioselections) {
                  <div class="d-flex px-0 mt-3">
                    @if (isActive) {
                      <div class="mt-2 d-flex flex-column position-relative">
                        <small class="text-secondary">{{ 'shareableProduct.menu' | transloco }}</small>
                        <i style="color:#108c9c;" class="pi pi-angle-double-right fs-4 cursor-pointer parent-container"
                        (click)="openProfileMenuSection()"></i>
                        <div class="position-absolute">
                          <div class="configuration-dialog border" [class.open]="sidebarVisible" [class.collapsed]="collapsed">
                            <div class="dialog-content">
                              <div class="d-flex justify-content-end text-end">
                                <i class="pi pi-angle-double-left fs-4 text-secondary cursor-pointer"
                                (click)="toggleSidebar()"></i>
                              </div>
                              <div class="fw-semibold fs-5">
                                {{ 'shareableProduct.configurationMenu' | transloco }}
                              </div>
                              <div class="column-options mt-2">
                                <div class="d-flex align-items-center ps-3">
                                  <p-radioButton name="columnCount" [value]="3" [(ngModel)]="numberOfColumnToShow"
                                    inputId="showThreeColumns" (onClick)="onColumnCountChange(numberOfColumnToShow)" />
                                    <label for="showThreeColumns" class="ms-2">{{ 'shareableProduct.show3Columns' | transloco }}</label>
                                  </div>
                                  <div class="d-flex align-items-center ps-3">
                                    <p-radioButton name="columnCount" [value]="4" [(ngModel)]="numberOfColumnToShow"
                                      inputId="showFourColumns" (onClick)="onColumnCountChange(numberOfColumnToShow)" />
                                      <label for="showFourColumns" class="ms-2">{{ 'shareableProduct.show4Columns' | transloco }}</label>
                                    </div>
                                    <div class="d-flex align-items-center ps-3">
                                      <p-radioButton name="columnCount" [value]="6" [(ngModel)]="numberOfColumnToShow"
                                        inputId="showSixColumns" (onClick)="onColumnCountChange(numberOfColumnToShow)" />
                                        <label for="showSixColumns" class="ms-2">{{ 'shareableProduct.show6Columns' | transloco }}</label>
                                      </div>
                                    </div>
                                    <div class="setting-option mt-2 ps-3">
                                      <p-checkbox [(ngModel)]="isShowProfile" [binary]="true" [label]="'shareableProduct.displayProfile' | transloco"
                                        name="displayProfile" (onChange)="onShowProfileChange($event)" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                            <div class="d-flex flex-column w-100">
                              @if (!portfolioselections) {
                                @if (isShowProfile) {
                                  <div class="table-toolbar bg-light p-4 rounded shadow-sm ">
                                    <div class="row align-items-center">
                                      <!-- Profile Section -->
                                      <div class="d-flex align-items-center mb-3">
                                        <!-- Profile Image -->
                                        @if (ProfilePicture) {
                                          <img [src]="ProfilePicture"
                                            class="rounded-circle me-2 cursor-pointer border border-primary" height="80" width="80"
                                            [alt]="'shareableProduct.profile' | transloco" />
                                        }
                                        <!-- Shared By and Business Name -->
                                        <div>
                                          <a href="javascript:void(0);" class="fs-5 fw-semibold cursor-pointer"
                                          (click)="navigateToViewProfile()">{{ UserName }}</a>
                                          <div class="text-muted small">
                                            @if (BusinessName) {
                                              <span class="fs-6">{{ 'shareableProduct.tradingAs' | transloco: { businessName: BusinessName } }}</span>
                                            }
                                            <span class="fs-6 ms-2">{{ 'shareableProduct.artworksSeparator' | transloco }}</span>
                                          </div>
                                        </div>
                                      </div>
                                      <!-- Description Section -->
                                      <div class="text-muted fst-italic mb-2">
                                        @if (AboutMe) {
                                          {{AboutMe}}
                                        }
                                        @if (!AboutMe) {
                                          {{ 'shareableProduct.exploreMagnificent' | transloco }}
                                        }
                                      </div>
                                      @if (CreatedDate) {
                                        <div class="text-muted">
                                          <span>{{ 'shareableProduct.sharedOn' | transloco: { date: (CreatedDate | date: "dd/MM/yyyy HH:mm a") } }}</span>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                }
                              }
                              <div class="d-flex justify-content-between w-100">
                                <div>
                                  @if (Title) {
                                    <h2 class="mt-3 mb-0 ps-4">{{Title}}</h2>
                                  }
                                </div>
                                <div class="mb-3 col-6">
                                  <div class="d-flex mt-4">
                                    <input type="text" id="shareLinkInput" class="form-control rounded-end-0" [(ngModel)]="shareLink"
                                      readonly>
                                      <button pButton type="button" class="p-button-rounded p-button-info ms-1" [label]="'shareableProduct.copy' | transloco"
                                      (click)="copyLink()"></button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                          @if (!isActive && artistProducts.length == 0 && portfolioList.length > 0) {
                            <div class="col-12 d-flex justify-content-center"
                              >
                              <span>{{ 'shareableProduct.portfolioInactive' | transloco }}</span>
                            </div>
                          }
                          <!-- <div class="d-flex justify-content-center" *ngIf="!isActive && galleryProducts.length == 0">
                          <span>Portfolio is inactive and its products cannot be edited.</span>
                        </div> -->
                        @if (isActive) {
                          <div class="{{portfolioselections ? 'col-9 ' : 'col-12'}}  mt-2  border px-3 py-3 bg-white  shadow-sm"
                            >
                            <div class="row mt-2">
                              @if (isArtist && !loadingArtistProducts) {
                                @for (product of artistProducts; track product) {
<div [ngClass]="{
                  'col-4': numberOfColumnToShow == 3,
                  'col-3': numberOfColumnToShow == 4,
                  'col-2': numberOfColumnToShow == 6 || numberOfColumnToShow == 0
                }" class="col-2 mb-4">
                                    <div
                                      class="d-flex flex-column align-items-center rounded-3 shadow-sm bg-white h-100 cursor-pointer product-background border"
                                      (click)="selectInventory(product, 'artist')">
                                      <div
                                        class="image-container d-flex justify-content-center align-items-center p-2 border-bottom w-100">
                                        <img [src]="product.ProductImgUrl || 'assets/images/No-Image.png'" alt="{{ product.Name }}"
                        class="img-fluid rounded" [ngClass]="{
                          'fixed-img-size-3': numberOfColumnToShow == 3,
                          'fixed-img-size-4': numberOfColumnToShow == 4
                        }" />
                                        </div>
                                        <div class="text-center px-2 py-2 w-100">
                                          <h3 class="card-title text-uppercase text-truncate small mb-0">{{ product.Name }}</h3>
                                        </div>
                                      </div>
                                    </div>
                                  }
                                  @if (!portfolioselections && portfolioList.length > 0 && isActive && artistProducts.length == 0) {
                                    <div class="d-flex justify-content-center"
                                      >
                                      <span>{{ 'shareableProduct.noArtistPortfolioProducts' | transloco }}</span>
                                    </div>
                                  }
                                  @if (portfolioselections && portfolioList.length > 0 && isActive && artistProducts.length == 0) {
                                    <div class="d-flex justify-content-center"
                                      >
                                      <span>{{ 'shareableProduct.noArtistProduct' | transloco }}</span>
                                    </div>
                                  }
                                }
                                @if (isGallery && !loadingGalleryProducts) {
                                  @for (product of galleryProducts; track product) {
<div [ngClass]="{
                  'col-4': numberOfColumnToShow == 3,
                  'col-3': numberOfColumnToShow == 4,
                  'col-2': numberOfColumnToShow == 6 || numberOfColumnToShow == 0
                }" class="col-2 mb-4">
                                      <div
                                        class="d-flex flex-column align-items-center rounded-3 shadow-sm bg-white h-100 cursor-pointer product-background border"
                                        (click)="selectInventory(product, 'gallery')">
                                        <div
                                          class="image-container d-flex justify-content-center align-items-center p-2 border-bottom w-100">
                                          <img [src]="product.ProductImgUrl || 'assets/images/No-Image.png'" alt="{{ product.Name }}"
                        class="img-fluid rounded" [ngClass]="{
                          'fixed-img-size-3': numberOfColumnToShow == 3,
                          'fixed-img-size-4': numberOfColumnToShow == 4
                        }" />
                                          </div>
                                          <div class="text-center px-2 py-2 w-100">
                                            <h3 class="card-title text-uppercase text-truncate small mb-0">{{ product.Name }}</h3>
                                          </div>
                                        </div>
                                      </div>
                                    }
                                    @if (!portfolioselections && portfolioList.length > 0 && isActive && galleryProducts.length == 0) {
                                      <div class="d-flex justify-content-center"
                                        >
                                        <span>{{ 'shareableProduct.noGalleryPortfolioProducts' | transloco }}</span>
                                      </div>
                                    }
                                    @if (portfolioselections && portfolioList.length > 0 && isActive && galleryProducts.length == 0) {
                                      <div class="d-flex justify-content-center"
                                        >
                                        <span>{{ 'shareableProduct.noGalleryProduct' | transloco }}</span>
                                      </div>
                                    }
                                  }
                                </div>
                              </div>
                            }

                            @if (portfolioselections && isActive) {
                              <div class="col-3 mt-2 border py-3 bg-light  shadow-sm">
                                <div class="row ">
                                  <div class="p-2">
                                    <div class="portfolio-header d-flex flex-column mb-4 px-3  p-2 py-3 shadow rounded bg-white">
                                      <!-- Title -->
                                      @if (Title) {
                                        <div class="fw-semibold fs-5 text-center text-uppercase mb-2">
                                          {{ Title }}
                                        </div>
                                      }
                                      <!-- Save Button -->
                                      @if (selectedArtistProductsInventory.length > 0 || selectedGalleryProductsInventory.length > 0) {
                                        <div
                                          class="d-flex justify-content-center my-3">
                                          <button pButton type="button" [label]="'shareableProduct.saveProducts' | transloco" icon="pi pi-save"
                                            class="p-button-sm p-button-outlined text-success" (click)="savePortfolioProducts(portfolioId)">
                                          </button>
                                        </div>
                                      }
                                      <!-- Section Heading -->
                                      <div class="d-flex justify-content-center mb-2">
                                        @if ((isArtist && selectedArtistProductsInventory.length > 0) || (isGallery && selectedGalleryProductsInventory.length > 0)) {
                                          <span
                                            class="badge text-white d-inline-flex align-items-center justify-content-center"
                                            style="background-color: #178d9b; font-weight: 700; width: 30px; height: 30px; border-radius: 50%;">
                                            {{ isArtist ? selectedArtistProductsInventory.length : selectedGalleryProductsInventory.length }}
                                          </span>
                                        }
                                      </div>
                                      <div class="fw-semibold fs-6 text-center mb-1 text-dark">
                                        {{ 'shareableProduct.selectedProducts' | transloco }}
                                      </div>
                                      <!-- Helper Text -->
                                      <div class="text-muted text-center small">
                                        {{ 'shareableProduct.selectedProductsHelp' | transloco }}
                                      </div>
                                    </div>
                                  </div>
                                  @if (isArtist) {
                                    @for (product of selectedArtistProductsInventory; track product; let i = $index) {
                                      <div class="col-6 drag-item mb-2 "
                                        [attr.data-index]="i"
                                        pDraggable (onDragStart)="onDragStart(product, i, 'artist')" (dragover)="onDragOver($event)"
                                        (onDrop)="onDrop($event, i, 'artist')" pDroppable>
                                        <div
                                          class="d-flex flex-column align-items-center rounded-3 shadow-sm bg-white h-100 cursor-pointer product-background border">
                                          <div
                                            class="image-container d-flex justify-content-center align-items-center p-2 border-bottom w-100"
                                            (click)="moveToCurrentInventory(product, 'artist')">
                                            <img [src]="product.ProductImgUrl ? product.ProductImgUrl : 'assets/images/No-Image.png'"
                                              alt="{{ product.Name }}" class="img-fluid" />
                                            </div>
                                            <div class="text-center px-2 py-2 w-100">
                                              <h3 class="card-title text-uppercase text-truncate small mb-0">{{ product.Name }}</h3>
                                            </div>
                                          </div>
                                        </div>
                                      }
                                    }
                                    @if (isGallery) {
                                      @for (product of selectedGalleryProductsInventory; track product; let i = $index) {
                                        <div class="col-6 mb-4 drag-item"
                                          [attr.data-index]="i"
                                          pDraggable (onDragStart)="onDragStart(product, i, 'gallery')" (dragover)="onDragOver($event)"
                                          (onDrop)="onDrop($event, i, 'gallery')" pDroppable>
                                          <div
                                            class="d-flex flex-column align-items-center rounded-3 shadow-sm bg-white h-100 cursor-pointer product-background border">
                                            <div
                                              class="image-container d-flex justify-content-center align-items-center p-2 border-bottom w-100"
                                              (click)="moveToCurrentInventory(product, 'gallery')">
                                              <img [src]="product.ProductImgUrl ? product.ProductImgUrl : 'assets/images/No-Image.png'"
                                                alt="{{ product.Name }}" class="img-fluid" />
                                              </div>
                                              <div class="text-center px-2 py-2 w-100">
                                                <h3 class="card-title text-uppercase text-truncate small mb-0">{{ product.Name }}</h3>
                                              </div>
                                            </div>
                                          </div>
                                        }
                                      }
                                    </div>
                                    @if ((isArtist && selectedArtistProductsInventory.length === 0) || (!isArtist && selectedGalleryProductsInventory.length === 0)) {
                                      <div
                                        class="d-flex justify-content-center">
                                        <span>{{ 'shareableProduct.noSelectedProducts' | transloco }}</span>
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            </div>


                          </div>
                        </div>
                      </div>






                      <p-dialog [showHeader]="false" [modal]="true" [(visible)]="showProductDialog" [resizable]="false" [draggable]="false"
                        styleClass="dialogcontent-without-padding" [style]="{ width: '1000px' }">
                        @if (showProductDialog) {
                          <app-artist-selected-product-dialog [ArtistProduct]="selectedProduct"
                            [GalleryProduct]="selectedGalleryProduct" [BusinessName]="BusinessName"
                          (closeDialog)="closeArtistSelectedProductDialog()"></app-artist-selected-product-dialog>
                        }
                      </p-dialog>

                      @if (isStripePlansDialogVisible) {
                        <stripe-payment-plan [isStripePaymentPlansDialogVisible]="isStripePlansDialogVisible" [stripeAllPlans]="stripePlans"
                          (onCloseStripePaymentPlanDailog)="onCloseStripePaymentDailog($event)">
                        </stripe-payment-plan>
                      }

                      <p-dialog [(visible)]="isUpgreadAccountDialogVisible" [header]="'shareableProduct.upgradeYourAccount' | transloco" [closable]="true" [modal]="true"
                        [responsive]="true" [style]="{width: '450px'}">
                        <div class="dialog-content">
                          <!-- Warning Section -->
                          <div class="alert alert-warning p-4 rounded-3 border-0 shadow-lg mb-4">
                            <div class="d-flex align-items-center">
                              <i class="pi pi-info-circle text-warning fs-3 me-3"></i>
                              <div>
                                <strong>{{ 'shareableProduct.limitedAccess' | transloco }}</strong>
                                <p class="mb-2">{{ 'shareableProduct.limitedAccessText' | transloco }}</p>
                              </div>
                            </div>
                          </div>

                          <!-- Main Content -->
                          <p class="lead">
                            {{ 'shareableProduct.maxPortfoliosReached' | transloco }}
                          </p>

                          <!-- Upgrade CTA -->
                          <div class="text-center mt-4">
                            <a href="javascript:void(0);" (click)="onUpgradeAccount()">
                              <img src="assets/images/upgrade-nag-button-200h.png" width="300" [alt]="'shareableProduct.upgradePlan' | transloco"
                                class="rounded shadow-lg img-fluid" />
                              </a>
                            </div>
                          </div>
                        </p-dialog>


                        <p-dialog [header]="isEditMode ? ('shareableProduct.editPortfolio' | transloco) : ('shareableProduct.createPortfolio' | transloco)" [(visible)]="displayPortfolioDialog"
                          [modal]="true" [style]="{ 'width': '560px', 'height': 'auto' }" (onHide)="closePortfolioDialog()">
                          <!-- Logo section -->
                          <div class="d-flex flex-column justify-content-center align-items-center p-2 mb-2">
                            <img src="assets/images/thumb_AFP-logo-v02-noTagline-800.png" class="img-fluid" style="max-width: 250px;"
                              [alt]="'shareableProduct.logo' | transloco" />
                            </div>

                            <div class="p-fluid px-2">
                              <form class="form-horizontal">
                                <div class="small text-muted">
                                  {{ 'shareableProduct.createPortfolioHelp' | transloco }}
                                </div>
                                <!-- Title Input -->
                                <div class="form-group mt-1">
                                  <label for="title" class="form-label">{{ 'shareableProduct.title' | transloco }}</label>
                                  <input type="text" id="title" pInputText [placeholder]="'shareableProduct.enterPortfolioTitle' | transloco"
                                    class="form-control form-control-sm w-100" [(ngModel)]="portfolio.Title" name="title" />
                                  </div>
                                  <div class="form-group mt-1">
                                    <label for="description" class="form-label">{{ 'shareableProduct.description' | transloco }}</label>
                                    <textarea id="description" name="description" [(ngModel)]="portfolio.Description" style="height: 150px;"
                                    [placeholder]="'shareableProduct.enterDetailedDescription' | transloco" class="form-control"></textarea>
                                  </div>
                                  <!-- Status Dropdown -->
                                  <div class="form-group mt-3">
                                    <label for="status" class="form-label">{{ 'shareableProduct.status' | transloco }}</label>
                                    @for (status of statusOptions; track status) {
                                      <div>
                                        <div class="form-check d-flex">
                                          <input class="form-check-input" type="radio" name="status" [value]="status.value"
                                            [checked]="portfolio.IsActive === status.value" (change)="onStatusChange(status.value)">
                                            <label class="form-check-label ms-2">{{ status.label }}</label>
                                          </div>
                                        </div>
                                      }
                                    </div>
                                    <!-- Buttons -->
                                    <div class="d-flex justify-content-end gap-2 mt-4">
                                      <button pButton type="button" [label]="'shareableProduct.cancel' | transloco" class="p-button-secondary p-button-outlined"
                                        (click)="closePortfolioDialog()">
                                      </button>
                                      <button pButton type="button" [label]="isEditMode ? ('shareableProduct.updatePortfolio' | transloco) : ('shareableProduct.savePortfolio' | transloco)"
                                        class="p-button-success p-button-outlined" [disabled]="!portfolio.Title" (click)="savePortfolio()">
                                      </button>
                                    </div>
                                  </form>
                                </div>
                              </p-dialog>